import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

const OverviewSkeletonCard = () => (
  <Box
    sx={{
      width: 270,
      height: 270,
      border: "1px solid #ddd",
      borderRadius: 2,
      overflow: "hidden",
      background: "#f9f9f9",
      display: "flex",
      flexDirection: "column",
      gap: 1,
      transform: "scale(1.08)",
      transformOrigin: "center",
    }}
  >
    {/* Header: dept name + menu icon */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#f5f5fd",
        borderBottom: "2px solid #e0e0e0",
        px: 1,
        py: 0.75,
      }}
    >
      <Skeleton width={120} height={24} />
      <Skeleton variant="circular" width={24} height={24} />
    </Box>

    {/* Total staff row */}
    <Skeleton width={160} height={18} sx={{ ml: 1 }} />

    {/* 6 stat rows */}
    <Box sx={{ px: 0.8 }}>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <Stack key={i} direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.4 }}>
          <Skeleton width={95} height={16} />
          <Skeleton width={28} height={16} />
        </Stack>
      ))}
    </Box>
  </Box>
);

const OverviewSkeletonGrid = ({ count = 8 }) => (
  <Box sx={{ paddingLeft: 1, paddingRight: 1 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(270px, 270px))",
        justifyContent: "center",
        gap: 8,
        mt: 2,
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <OverviewSkeletonCard key={i} />
      ))}
    </Box>
  </Box>
);

export default OverviewSkeletonGrid;
